module.exports = __webpack_public_path__ + "img/cardIcon.fde68dda.png";